import React from 'react'
import { Drawer, Typography  } from "antd";
const { Title, Text } = Typography;
const SideDrawer = (props) => {

    const {
        title,
        sub_title,
        width, 
        open, 
        placement, 
        closable,
        children, 
        drawer_name
    } = props;

    return (
        <>
            <Drawer
                title={
                    <div>
                        <Title className='mb-0 fs-3 text-gray-800'>
                            {title ? title : ''}
                        </Title>
                        <Text className='text-gray-400'>
                            {sub_title ? sub_title : ''}
                        </Text>
                    </div>
                }
                width={width}
                open={open}
                placement={placement}
                closable={closable}
                extra={
                    <a className="btn btn-sm btn-dark me-3 px-4" 
                        onClick={() => props.drawerOnClose(drawer_name)}
                    >
                        Close
                    </a>
                }
                styles={{ body: { overflowX: "hidden" } }}
            >
                {children}
            </Drawer>
        </>
    )
}

export default SideDrawer